import { Col, Row } from "antd";
import { dashboardApi } from "apis";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatPrice } from "utils/formatPrice";
import AreaChart from "./AreaChart";
import PieChart from "./PieChart";
import ProgressChart from "./ProgressChart";

import * as S from "./style";
import TableDateDelay from "./TableDateDelay";
import TableMortgage from "./TableMortgage";

function DashBoard() {
  const { t } = useTranslation();
  const [data, setData] = useState<any>({});

  useEffect(() => {
    (async function getDataDashboard() {
      const res: any = await dashboardApi();
      if (res?.result) {
        setData(res.data);
      }
    })();
  }, []);

  return (
    <S.Container className="box-container">
      <Row gutter={[20, 0]} align="stretch">
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_LOAN_AMOUNT")}</div>
              <div>{formatPrice(data?.totalLoanAmount)} 원</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.totalRefundAmount)}원`,
                  type: "상환완료액",
                  value: Number(
                    formatPrice(
                      (data?.totalRefundAmount / data?.totalLoanAmount) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.totalLoanBalance)}원`,
                  type: "대출잔액",
                  value: Number(
                    formatPrice(
                      (data?.totalLoanBalance / data?.totalLoanAmount) * 100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_BALANCE_COMPLETE_REFUND")}</div>
              <div>{formatPrice(data?.totalRefundAmount)} 원</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.finishContactAmount)}원`,
                  type: "계약종료",
                  value: Number(
                    formatPrice(
                      (data?.finishContactAmount / data?.totalRefundAmount) *
                        100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.processContactAmount)}원`,
                  type: "계약중(중도상환)",
                  value: Number(
                    formatPrice(
                      (data?.processContactAmount / data?.totalRefundAmount) *
                        100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_LOAN_BALANCE")}</div>
              <div>{formatPrice(data?.totalLoanBalance)} 원</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.loanNormal)}원`,
                  type: "정상대출",
                  value: Number(
                    formatPrice(
                      (data?.loanNormal / data?.totalLoanBalance) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.latePaying)}원`,
                  type: "연체중",
                  value: Number(
                    formatPrice(
                      (data?.latePaying / data?.totalLoanBalance) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.unusualLoss)}원`,
                  type: "기한이익상실",
                  value: Number(
                    formatPrice(
                      (data?.unusualLoss / data?.totalLoanBalance) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.reselling)}원`,
                  type: "매각중",
                  value: Number(
                    formatPrice(
                      (data?.reselling / data?.totalLoanBalance) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.resaleComplete)}원`,
                  type: "매각완료",
                  value: Number(
                    formatPrice(
                      (data?.resaleComplete / data?.totalLoanBalance) * 100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box full-height">
            <div className="box-content ">
              <div className="title">{t("DASH_BOARD_AVERAGE_LOAN_AMOUNT")}</div>
              <div>
                <div className="title">{t("DASH_BOARD_END_CONTRACT")}</div>
                <div className="sub-title">
                  {formatPrice(data?.loanAmountAvgEndContact)} 원
                </div>
              </div>
              <div>
                <div className="title">
                  {t("DASH_BOARD_CONTRACT_IN_PROGRESS")}
                </div>
                <div className="sub-title">
                  {formatPrice(data?.loanAmountAvgProcessContact)} 원
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row gutter={[20, 0]} align="stretch">
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_AMOUNT_INTEREST")}</div>
              <div>{formatPrice(data?.totalInterestIncurred)} 원</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.interestLate)}원`,
                  type: "연체이자",
                  value: Number(
                    formatPrice(
                      (data?.interestLate / data?.totalInterestIncurred) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.interestNormal)}원`,
                  type: "정상이자",
                  value: Number(
                    formatPrice(
                      (data?.interestNormal / data?.totalInterestIncurred) * 100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_NORMAL_INTEREST")}</div>
              <div>{formatPrice(data?.interestNormal)} 원</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.interestNormalCollected)}원`,
                  type: "수취이자",
                  value: Number(
                    formatPrice(
                      (data?.interestNormalCollected / data?.interestNormal) *
                        100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.interestNormalUncollected)}원`,
                  type: "미수취이자",
                  value: Number(
                    formatPrice(
                      (data?.interestNormalUncollected / data?.interestNormal) *
                        100
                    )
                  ),
                },
              ]}
              color={["#33CCCC", "#FF6699"]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_DELAY_INTEREST")}</div>
              <div>{formatPrice(data?.interestLate)} 원</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.interestLateCollected)}원`,
                  type: "수취이자",
                  value: Number(
                    formatPrice(
                      (data?.interestLateCollected / data?.interestLate) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.interestLateUncollected)}원`,
                  type: "미수취이자",
                  value: Number(
                    formatPrice(
                      (data?.interestLateUncollected / data?.interestLate) * 100
                    )
                  ),
                },
              ]}
              color={["#FF3366", "#FFCC00"]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box full-height">
            <div className="box-content ">
              <div className="title">{t("DASH_BOARD_AVERAGE_INTEREST")}</div>
              <div>
                <div className="title">{t("DASH_BOARD_END_CONTRACT")}</div>
                <div className="sub-title">
                  {formatPrice(data?.interestAvgEndContract)} %
                </div>
              </div>
              <div>
                <div className="title">
                  {t("DASH_BOARD_CONTRACT_IN_PROGRESS")}
                </div>
                <div className="sub-title">
                  {formatPrice(data?.interestAvgProcessContact)} %
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row gutter={[20, 0]} align="stretch">
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_PRODUCT_MORTGAGE")}</div>
              <div>{formatPrice(data?.totalMortgage)} 건</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.mortgageInPreservation)}건`,
                  type: "보관중",
                  value: Number(
                    formatPrice(
                      (data?.mortgageInPreservation / data?.totalMortgage) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.mortgageLoaning)}건`,
                  type: "대여중",
                  value: Number(
                    formatPrice(
                      (data?.mortgageLoaning / data?.totalMortgage) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.mortgageReturnMidway)}건`,
                  type: "중도반출",
                  value: Number(
                    formatPrice(
                      (data?.mortgageReturnMidway / data?.totalMortgage) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.mortgageReturnNormal)}건`,
                  type: "정상반출",
                  value: Number(
                    formatPrice(
                      (data?.mortgageReturnNormal / data?.totalMortgage) * 100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box full-height">
            <div>
              <div className="title-progresschart">
                {t("DASH_BOARD_CURRENT_LTV")}
              </div>
              <ProgressChart percent={data?.totalCurrentLtv} />
            </div>
          </div>
        </Col>
        <Col span={6} className="box-progresschart">
          <div className="box full-height">
            <div className="title">{t("DASH_BOARD_AVERAGE_LTV")}</div>
            <Row gutter={[20, 0]} align="stretch" justify="center">
              {/* <Col span={10}>
                <div className="sub-title">{t("DASH_BOARD_END_CONTRACT")}</div>
                <ProgressChart percent={data?.endContractLtv} />
              </Col> */}
              <Col span={10}>
                <div className="sub-title">
                  {t("DASH_BOARD_CONTRACT_IN_PROGRESS")}
                </div>
                <ProgressChart percent={data?.processContractLtv} />
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={6}>
          <div className="box full-height">
            <div>
              <div className="title-progresschart">
                {t("DASH_BOARD_LATE_PAYMENT_RATE")}
              </div>
              <ProgressChart percent={data?.paymentLateRate} />
            </div>
          </div>
        </Col>
      </Row>
      <Row gutter={[20, 0]} align="stretch">
        {/* <Col span={6}>
          <div className="box full-height">
            <div>
              <div className="title-progresschart">
                {t("DASH_BOARD_LATE_PAYMENT_RATE")}
              </div>
              <ProgressChart percent={data?.paymentLateRate} />
            </div>
          </div>
        </Col> */}
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_LOAN_BORROWER")}</div>
              <div>{formatPrice(data?.totalBorrowers)} 명</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.personalBorrower)}명`,
                  type: "개인",
                  value: Number(
                    formatPrice(
                      (data?.personalBorrower / data?.totalBorrowers) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.companyBorrower)}명`,
                  type: "법인",
                  value: Number(
                    formatPrice(
                      (data?.companyBorrower / data?.totalBorrowers) * 100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_AMOUNT_CONTRACT")}</div>
              <div>{formatPrice(data?.totalLoanContract)} 건</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.totalPersonalLoan)}건`,
                  type: "개인",
                  value: Number(
                    formatPrice(
                      (data?.totalPersonalLoan / data?.totalLoanContract) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.totalCompanyLoan)}건`,
                  type: "법인",
                  value: Number(
                    formatPrice(
                      (data?.totalCompanyLoan / data?.totalLoanContract) * 100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box">
            <div className="box-title">
              <div>{t("DASH_BOARD_TOTAL_AMOUNT_DELAY")}</div>
              <div>{formatPrice(data?.totalLoanLate)} 건</div>
            </div>
            <PieChart
              data={[
                {
                  price: `${formatPrice(data?.totalPersonalLoanLate)}건`,
                  type: "개인",
                  value: Number(
                    formatPrice(
                      (data?.totalPersonalLoanLate / data?.totalLoanLate) * 100
                    )
                  ),
                },
                {
                  price: `${formatPrice(data?.totalCompanyLoanLate)}건`,
                  type: "법인",
                  value: Number(
                    formatPrice(
                      (data?.totalCompanyLoanLate / data?.totalLoanLate) * 100
                    )
                  ),
                },
              ]}
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="box full-height">
            <div className="box-area">
              <div className="title">{t("DASH_BOARD_TOTAL_AMOUNT_OWNER")}</div>
              <div className="sub-title">
                {formatPrice(data?.totalLossInterest)} 원
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row gutter={[20, 0]} align="stretch">
        {/* <Col span={6}>
          <div className="box full-height">
            <div className="box-area">
              <div className="title">{t("DASH_BOARD_TOTAL_AMOUNT_OWNER")}</div>
              <div className="sub-title">
                {formatPrice(data?.totalLossInterest)} 원
              </div>
            </div>
          </div>
        </Col> */}
        {/* <Col span={18}> */}
        <Col span={24}>
          <div className="box">
            <div className="box-title__area">
              <div>{t("DASH_BOARD_CONTRACT_STATUS")}</div>
            </div>
            <AreaChart
              data={[
                {
                  title: "상환중",
                  value: Number(formatPrice(data?.loanRefundProcessNumber)),
                },
                {
                  title: "일부상환",
                  value: Number(formatPrice(data?.loanPartialRefundNumber)),
                },
                {
                  title: "연체중",
                  value: Number(formatPrice(data?.loanLatePaymentNumber)),
                },
                {
                  title: "기한이익상실",
                  value: Number(formatPrice(data?.loanLossInterestNumber)),
                },
                {
                  title: "매각중",
                  value: Number(formatPrice(data?.loanResellProcessNumber)),
                },
                {
                  title: "매각완료",
                  value: Number(formatPrice(data?.loanResellCompleteNumber)),
                },
                {
                  title: "상환완료(정상)",
                  value: Number(
                    formatPrice(data?.loanRefundCompleteNormalNumber)
                  ),
                },
                {
                  title: "상환완료(연체)",
                  value: Number(
                    formatPrice(data?.loanRefundCompleteLateNumber)
                  ),
                },
                {
                  title: "상환완료(매각)",
                  value: Number(
                    formatPrice(data?.loanRefundCompleteResellNumber)
                  ),
                },
              ]}
            />
          </div>
        </Col>
      </Row>
      <div className="box">
        <div className="title-table">
          {t("DASHBOARD_TABLE_TOP10_DELAY_TIME")}
        </div>
        <TableDateDelay data={data?.top10LoanLate} />
      </div>
      <div className="box">
        <div className="title-table">{t("DASHBOARD_TABLE_TOP10_END_HD")}</div>
        <TableDateDelay data={data?.top10LoanLongTime} />
      </div>
      <div className="box">
        <div className="title-table">{t("DASHBOARD_TABLE_TOP10_MORTGAGE")}</div>
        <TableMortgage data={data?.top10ManyMortgage} />
      </div>
    </S.Container>
  );
}

export default DashBoard;
